// Components/PDF/PdfModal.jsx
import React from "react";
import "../../../../../css/AdviserSupport/ContactList/Modal.css"; // optional if you keep styles separate

const Modal = ({ open, onClose, children, title = "Preview" }) => {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
